import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import {useTranslation} from 'react-i18next';


const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 10,
        fontSize: 20,
        
    },
    to: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
  });

 
  const CompanyAddress = ({adr}) => {

    const [t] = useTranslation(); 

    return(
    <View style={styles.headerContainer}>   
        <table style={{width: '100%', marginLeft: '10px'}}>
            <tr><td><Text>{adr.header}</Text></td></tr>
            <tr><td><Text style={{fontWeight: 'bold' }}>{adr.companyName}</Text></td></tr>
            <tr><td><Text>{adr.companyAddressLine1}</Text></td></tr>
            <tr><td><Text>{adr.companyAddressLine2}</Text></td></tr>
            <tr><td><Text>{t('general.label.businessId')}: {adr.companyBusinessId}</Text></td></tr>
            <tr><td><Text>{t('general.label.taxId')}: {adr.companyTaxId}</Text></td></tr>
            <tr><td><Text>{t('general.label.vatNo')}: {adr.companyVatNo}</Text></td></tr>
        </table>             
      
    </View>

  )};
  
  export default CompanyAddress